<template>
  <svg :class="svgClass" :style="styles" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
    styles: {
      type: String,
      default: '',
    },
    // width: {
    //   type: String,
    //   default: '20px'
    // },
    // height: {
    //   type: String,
    //   default: '20px'
    // }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  },
}
</script>

<style scoped>

</style>
